export default __webpack_public_path__ + "static/media/marketkit.e2c56670.svg";